module.exports = __webpack_public_path__ + "img/saddle-cloths-12.cebf2c91.svg";